import React from "react"
import { Table } from "antd"

const AntdTable = ({
  loading,
  columns,
  rows,
  scroll,
  title,
  setPage,
  setPageSize,
  page,
  total,
  onClickRowOne,
  pageSize,
  onChange,
  rowClassName,
}) => {
  return (
    <div style={{ overflowX: "auto" }}>
      <Table
        size='small'
        tableLayout='fixed'
        loading={loading}
        bordered
        columns={columns}
        dataSource={rows}
        scroll={scroll}
        title={title}
        pagination={{
          position: ["bottomRight"],
          pageSizeOptions: [20, 40, 60, 80],
          defaultPageSize: pageSize,
          onChange: (page, pageSize) => {
            setPage(page)
            setPageSize(pageSize)
          },
          defaultCurrent: page,
          total: total,
          current: page,
        }}
        onRow={(record, rowIndex) => {
          return {
            onClick: () => {
              onClickRowOne(record)
            },
          }
        }}
        onChange={onChange}
        rowClassName={rowClassName}
      />
    </div>
  )
}

export default AntdTable
